import { render } from "./NavBar.vue?vue&type=template&id=ba0468c2&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=ba0468c2&lang=scss&scoped=true"

import exportComponent from "/Users/li/Golang/supergroup.mixin.one/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba0468c2"]])

export default __exports__